import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d420976"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src", "alt", "onMouseover", "onTouchstart"]
const _hoisted_2 = ["src", "alt", "onClick"]
const _hoisted_3 = { class: "info" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "date" }
const _hoisted_6 = { class: "author" }

import { storeToRefs } from 'pinia';
import { useTab, useMedia } from '@/store';
import { MediaType } from '@/types/enums';
import { useI18n } from 'vue-i18n';

export default /*#__PURE__*/_defineComponent({
  __name: 'VideosItem',
  setup(__props) {

const { media } = storeToRefs(useTab());
const { player } = storeToRefs(useMedia());
const {
  updateIsEnlarged,
  updateThumbnail,
  updateYoutube,
  updateYoutubeCover,
  updatePlayerState,
  closeMedia,
} = useMedia();
const enlargeImg = (img: string, name: string) => {
  // ensure clear youtube video data
  closeMedia();
  updateIsEnlarged(true);
  updateThumbnail(img);
  /* eslint-disable @typescript-eslint/camelcase */
  window.gtag('event', 'click_img', {
    img_name: name,
  });
};
const playVideo = (event: Event) => {
  updateIsEnlarged(true);
  updateYoutubeCover(event.target?.src);
  try {
    player.value.playVideo();
  } catch (err) {
    updatePlayerState('cued');
  }
};
const { t } = useI18n();

return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(media), (item, index) => {
    return (_openBlock(), _createElementBlock("div", {
      key: index,
      class: _normalizeClass(['video', { 'video--pinned': item.isPinned }])
    }, [
      (item.type === _unref(MediaType).Video)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: "thumbnail",
            src: 
          item.thumbnail ||
          `https://img.youtube.com/vi/${item.info}/sddefault.jpg`
        ,
            alt: item.title,
            draggable: "false",
            onMouseover: ($event: any) => (_unref(updateYoutube)(item.info)),
            onTouchstart: ($event: any) => (_unref(updateYoutube)(item.info)),
            onClick: playVideo
          }, null, 40, _hoisted_1))
        : _createCommentVNode("", true),
      (item.type === _unref(MediaType).Image)
        ? (_openBlock(), _createElementBlock("img", {
            key: 1,
            class: "thumbnail",
            src: item.thumbnail || item.info,
            alt: item.title,
            draggable: "false",
            onClick: ($event: any) => (enlargeImg(item.info || item.thumbnail || '', item.title))
          }, null, 8, _hoisted_2))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(item.title), 1),
        _createElementVNode("time", _hoisted_5, _toDisplayString(_unref(t)('ITEM_DATE', { mm: item.month, dd: item.day })), 1)
      ]),
      _createElementVNode("div", _hoisted_6, _toDisplayString(item.author), 1)
    ], 2))
  }), 128))
}
}

})